var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutubeRound = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6562 9.90625C21.4688 9.15625 20.875 8.5625 20.1562 8.375C18.8125 8 13.5 8 13.5 8C13.5 8 8.15625 8 6.8125 8.375C6.09375 8.5625 5.5 9.15625 5.3125 9.90625C4.9375 11.2188 4.9375 14.0312 4.9375 14.0312C4.9375 14.0312 4.9375 16.8125 5.3125 18.1562C5.5 18.9062 6.09375 19.4688 6.8125 19.6562C8.15625 20 13.5 20 13.5 20C13.5 20 18.8125 20 20.1562 19.6562C20.875 19.4688 21.4688 18.9062 21.6562 18.1562C22.0312 16.8125 22.0312 14.0312 22.0312 14.0312C22.0312 14.0312 22.0312 11.2188 21.6562 9.90625ZM11.75 16.5625V11.5L16.1875 14.0312L11.75 16.5625Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube-round.f6cd9e1753a6acbd4527096c938a1feb.svg";